// Shared so skeleton and real rows are exactly the same height (no jump on load).
export const ROW_HEIGHT = 64;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/constants.js
 **/